module.exports = require("./fa-IR.js");